var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"value":true,"persistent":"","max-width":_vm.maxWidthFormatted}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }